import PropTypes from 'prop-types'
import React from 'react'

import Icon from 'components/Icon'
import { Text } from 'styles/components/typography'

import { Wrapper, PlusIcon } from './styles'

const TextWithPlus = ({ text }) => {
  if (!text) {
    return null
  }

  return (
    <Wrapper>
      <PlusIcon>
        <Icon id="plus" />
      </PlusIcon>
      <Text
        dangerouslySetInnerHTML={{
          __html: text,
        }}
      />
    </Wrapper>
  )
}

TextWithPlus.propTypes = {
  text: PropTypes.string,
}

export default TextWithPlus
